/** Shared Midpoint brand assets (map header + Client Views). */
export const MIDPOINT_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/assets/midpoint_logo-e1537655357232.png`;
export const MIDPOINT_LOGO_WHITE_SRC = `${process.env.PUBLIC_URL || ""}/assets/midpoint-media/logo_white.png`;
